<template>
    <v-row 
        justify="center" 
        align="center" 
    >
        <v-col>
            <v-row align="center" justify="center">
                <v-progress-circular
                    :size="60"
                    :width="4"
                    color="white"
                    indeterminate
                ></v-progress-circular>
            </v-row>
            <v-row align="center" justify="center" style="white" class="mt-4">
                <v-card color="rgba(0,0,0,0.2)" dark class="pa-1 pl-4 pr-4">
                    {{this.value}}
                </v-card>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'DateEditor',
        props: {
            //Current loading text
            value: {
                default: "Loading...",
                type: String
            }
        }
    }
</script>